import React from 'react';
import { GlobeIcon } from 'lucide-react';
export function LocalCurrencyNote({
  className = ''
}: {
  className?: string;
}) {
  return <p className={`flex items-start justify-center gap-1.5 text-sm text-muted ${className}`} data-id="element-150" data-mp="154mz02fjtb03">
      <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-151" data-mp="103h5i2e2djpi" />
      <span data-id="element-152" data-mp="v4w788idha3p">Paga en tu moneda local. El importe final se muestra en el checkout según tu país.</span>
    </p>;
}